/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';

export interface ApiCustomerAllGet$Json$Params {
}

export function apiCustomerAllGet$Json(http: HttpClient, rootUrl: string, params?: ApiCustomerAllGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCustomerAllGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerDto>>;
    })
  );
}

apiCustomerAllGet$Json.PATH = '/api/Customer/all';
